import React, { useState, useRef, useEffect } from "react";
import { RiChatSmile3Line, RiSendPlane2Line, RiCloseFill } from "react-icons/ri";
import AOS from "aos";
import "aos/dist/aos.css";
import { sendChatMessage } from "../server/apihelper";

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);
  const chatRef = useRef(null); // 👈 Reference for chat window

  // 🌀 AOS animation init
  useEffect(() => {
    AOS.init({ duration: 600 });
  }, []);

  // 👇 Auto-scroll to bottom when new message arrives
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // 🧠 Detect clicks outside to close chatbot
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (chatRef.current && !chatRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  // 🏁 Open/close chat toggle
  const toggleChat = () => {
    setIsOpen((prev) => !prev);
    if (!isOpen && messages.length === 0) {
      setMessages([
        {
          role: "assistant",
          content:
            "Welcome to McGAN's! I'm Mira. We're proud to be Tamil Nadu's #1 and a nationally top-ranked architecture college in India . May I know your name?",
        },
      ]);
    }
  };

  // 🚀 Send message
  const sendMessage = async () => {
    if (!input.trim()) return;
    const userMsg = { role: "user", content: input };
    setMessages((prev) => [...prev, userMsg]);
    setInput("");
    setIsTyping(true);

    try {
      const reply = await sendChatMessage(input);
      const botMsg = { role: "assistant", content: reply };
      setMessages((prev) => [...prev, botMsg]);
    } catch {
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: "⚠️ Connection error. Please try again." },
      ]);
    } finally {
      setIsTyping(false);
    }
  };

  // 🔄 Handle Enter key
  const handleKeyPress = (e) => {
    if (e.key === "Enter") sendMessage();
  };

  return (
    <>
      {/* 🟢 Floating Chat Icon */}
      <div className="chat-floating-container">
  <div className="chatbot-launcher" onClick={toggleChat}>
    <RiChatSmile3Line size={26} />
  </div>
</div>


      {/* 💬 Chat Window */}
      {isOpen && (
        <div className="chatbot-window" data-aos="zoom-in-up" ref={chatRef}>
          <div className="chatbot-header">
            <span>🏛️ McGAN’S Architecture Assistant</span>
            <RiCloseFill className="chatbot-close" onClick={toggleChat} size={22} />
          </div>

          <div className="chatbot-body">
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`chat-msg ${msg.role === "user" ? "user-msg" : "bot-msg"}`}
              >
                {msg.content}
              </div>
            ))}

            {isTyping && (
              <div className="bot-msg typing">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
            )}

            <div ref={messagesEndRef} />
          </div>

          <div className="chatbot-input">
            <input
              type="text"
              placeholder="Ask about McGAN’S Architecture..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button onClick={sendMessage}>
              <RiSendPlane2Line size={20} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatBot;
